import React from 'react';
import { Crown, Users, Star } from 'lucide-react';
import { Link } from 'react-router-dom';

const TierBadge = ({ tier }) => {
  if (!tier) return null;

  const getTierConfig = () => {
    switch (tier) {
      case 'supporter':
        return {
          name: 'Supporter',
          icon: <Users className="w-4 h-4" />,
          bgColor: 'bg-blue-500',
          textColor: 'text-white'
        };
      case 'family':
        return {
          name: 'Family',
          icon: <Star className="w-4 h-4" />,
          bgColor: 'bg-purple-500',
          textColor: 'text-white'
        };
      case 'legacy':
        return {
          name: 'Legacy',
          icon: <Crown className="w-4 h-4" />,
          bgColor: 'bg-[#D4AF37]',
          textColor: 'text-black'
        };
      default:
        return null;
    }
  };

  const config = getTierConfig();
  if (!config) return null;

  return (
    <Link
      to="/subscription"
      className={`inline-flex items-center gap-2 px-4 py-2 rounded-full ${config.bgColor} ${config.textColor} text-sm font-bold hover:opacity-90 transition-opacity`}
    >
      {config.icon}
      <span>{config.name} Member</span>
    </Link>
  );
};

export default TierBadge;
